export enum NodeDisplayType {
  Id = 'id',
  Address = 'address',
}
